module.exports = "/packs/media/images/fitness_1-e6d53f03fa8c92b382338065c8b3a7d6.jpg";